function frozen(entries) {
    return Object.freeze(entries.map((entry) => Object.freeze({ ...entry })));
}
export const REVIEWED_DESTINATION_PREFIX = Object.freeze({
    /*
     * Greece (+30). Read 2026-09-29 from:
     *  [1] EETT, "Presentation of national ITU-T E.164 numbering plan for country code +30", ITU-T
     *      Operational Bulletin communications of 9.IX.2021 and 17.IX.2021
     *      https://www.itu.int/dms_pub/itu-t/oth/02/02/T02020000550002PDFE.pdf — NSN 3 to 10 digits;
     *      range "1" (3–6 digits): "Emergency service numbers, social value services, directory
     *      enquiries services, value added services, commercial numbers, public services"; 806, 812,
     *      825, 850, 875: "Value added services (charged 0.06 euro/min, 0,12 euro/min, 0.25 euro/min,
     *      0.50 euro/min and 0.75 euro/min respectively)"; 896 and 899: "Dial up numbers"; 90: "Value
     *      added services"; 70: "Personal numbers".
     *  [2] EETT, consumer FAQ "Premium rate services — Information"
     *      https://www.eett.gr/en/docs/faq-for-consumers/premium-rate-services/information/ — "numbers
     *      starting with 901, 909, 806, 812, 825, 850, 875, 14, 190–195, 54, etc."
     *  [3] The emergency numbers 100, 108, 112, 166 and 199, as listed in "Telephone numbers in Greece"
     *      https://en.wikipedia.org/wiki/Telephone_numbers_in_Greece — each also inside [1]'s range
     *      "1", which is refused as a whole, so the list below documents rather than decides.
     *
     * What is NOT refused here, on purpose: geographic 2x, mobile 690–691 / 693–695 / 697–699 /
     * 685–689, freephone 800, shared cost 801 (capped at the geographic price, [1]), VPN 50 and M2M
     * 40–42 — none is emergency, short-code or premium-rate in [1] or [2].
     */
    GR: Object.freeze({
        callingCode: "30",
        nationalSignificantLength: 10,
        emergency: frozen([
            { prefix: "112", label: "European emergency number [3]" },
            { prefix: "100", label: "Hellenic Police [3]" },
            { prefix: "166", label: "EKAV, the national ambulance service [3]" },
            { prefix: "199", label: "Hellenic Fire Service [3]" },
            { prefix: "108", label: "Hellenic Coast Guard [3]" },
        ]),
        shortCode: frozen([
            {
                prefix: "1",
                label: "emergency, social value (116xxx), directory enquiries (118xx), value added, commercial and public-service short codes, 3–6 digits [1]",
            },
        ]),
        premiumRate: frozen([
            { prefix: "90", label: "value added services: 901 (addressed to all), 909 (adults only) [1][2]" },
            { prefix: "806", label: "value added services at 0.06 EUR/min [1][2]" },
            { prefix: "812", label: "value added services at 0.12 EUR/min [1][2]" },
            { prefix: "825", label: "value added services at 0.25 EUR/min [1][2]" },
            { prefix: "850", label: "value added services at 0.50 EUR/min [1][2]" },
            { prefix: "875", label: "value added services at 0.75 EUR/min [1][2]" },
            { prefix: "896", label: "dial-up numbers [1]" },
            { prefix: "899", label: "dial-up numbers [1]" },
            {
                prefix: "70",
                label: "personal numbers [1] — forwarded at a tariff the number's holder chooses, not a subscriber line; refused as special tariff (fail closed, R-SEC-5)",
            },
            { prefix: "14", label: "premium-rate short codes [2]" },
            { prefix: "190", label: "premium-rate short codes [2]" },
            { prefix: "191", label: "premium-rate short codes [2]" },
            { prefix: "192", label: "premium-rate short codes [2]" },
            { prefix: "193", label: "premium-rate short codes [2]" },
            { prefix: "194", label: "premium-rate short codes [2]" },
            { prefix: "195", label: "premium-rate short codes [2]" },
            { prefix: "54", label: "premium-rate short codes [2]" },
        ]),
        source: Object.freeze([
            "https://www.itu.int/dms_pub/itu-t/oth/02/02/T02020000550002PDFE.pdf",
            "https://www.eett.gr/en/docs/faq-for-consumers/premium-rate-services/information/",
            "https://en.wikipedia.org/wiki/Telephone_numbers_in_Greece",
        ]),
        readAt: "2026-09-29",
    }),
});
/** The countries a trunk may dial at all: the reviewed table's key set (DD8-20). */
export const REVIEWED_DESTINATION_COUNTRY = Object.freeze(Object.keys(REVIEWED_DESTINATION_PREFIX));
/** Whether `country` has a reviewed entry in the launch data. */
export function isReviewedDestinationCountry(country) {
    return Object.hasOwn(REVIEWED_DESTINATION_PREFIX, country);
}
//# sourceMappingURL=destination-prefix.js.map